// extracted by mini-css-extract-plugin
export default {"ClientDetail":"ClientDetail_ClientDetail__3g7or","tableResponsive":"ClientDetail_tableResponsive__QSQnm"};